<i18n lang='yml' src='../i18n/InventoryExamReport.yml'></i18n>
<template>
  <div>
    <h5 class="heading-page inventory-report-search">
      {{$t('page_headers.location')}}
      <select id="dropdown_logbook_approval" :name="$t('dropdown_logbook_approval')" 
        class="select-dropdown custom-select form-control-sm"
        v-model="selectedLocation"
        @change="onChange($event)"
      >
        <option :value="null">
          {{$t('root')}}
        </option>
        <option v-for="location in locationData" :key="location.id" :value="{id: location.id, value: location.label}">
          {{ location.label }}
        </option>
      </select>
    </h5>

    <div class="inventory-report">
      <div class="col-trans-right white-bg">
        <span class="inventory-report-header"><h4>{{$t('page_headers.report_header')}}</h4></span>
        <div class="header-second-row">
          <h5 class="heading-page">
            {{$t('page_headers.location')}}{{ selectedLocation != null ?  selectedLocation.value : $t('root') }}
          </h5>
          <h5 class="heading-page">{{$t('page_headers.date')}} {{formatDate(Date())}}</h5>
          <h5 class="heading-page">{{$t('page_headers.requested_by')}}{{user_name}}</h5>
        </div>
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th scope="col" colspan="3">{{$t('table_headers.exams')}}</th>
              <th scope="col">{{$t('table_headers.items_in_inventory')}}</th>
              <th scope="col" colspan="3">{{$t('table_headers.control_numbers')}}</th>
              <th scope="col" colspan="2"></th>
              <th scope="col" style="padding-left:0.4rem;">{{$t('table_headers.comments')}}</th>
            </tr>
            <tr>
              <th scope="col">{{$t('table_headers.code')}}</th>
              <th scope="col">{{$t('table_headers.version_number')}}</th>
              <th scope="col" style="padding-left:0.4rem;">{{$t('table_headers.description')}}</th>
              <th scope="col"></th>
              <th scope="col">{{$t('table_headers.received')}}</th>
              <th scope="col"><div v-html="$t('table_headers.not_available')"/></th>
              <th scope="col" style="padding-left:0.4rem;">{{$t('table_headers.signed_out')}}</th>
              <th scope="col">{{$t('table_headers.sent')}}</th>
              <th scope="col">{{$t('table_headers.recalled')}}</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody v-if="tempData.length != 0">
            <tr v-for="exam in tempData" :key="exam.id">
              <td>{{exam.test_id}}</td>
              <td>{{exam.version_name}}</td>
              <td>{{exam.name[locale]}}</td>
              <td>{{sortBooksByStatus(exam.inventory_items).length}}</td>
              <td>{{listBooksByStatus(exam.inventory_items, 'received')}}</td>
              <td>{{listBooksByStatus(exam.inventory_items, 'not_available')}}</td>
              <td>{{listBooksByStatus(exam.inventory_items, 'signed_out')}}</td>
              <td>{{listBooksByStatus(exam.inventory_items, 'sent')}}</td>
              <td>{{listBooksByStatus(exam.inventory_items, 'recalled')}}</td>
              <!-- Comments and notes are empty as notes will be taken on paper -->
              <td></td>
            </tr>
          </tbody>
        </table>
        <div class="alert alert-warning" role="alert" v-if="tempData.length <= 0">
          {{ $t('no_data') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import pagination from '../../../../shared/pagination/Pagination.vue';
  import {formatDate} from '../../../../shared/typescripts/dates.ts'

  export default {
    components: { pagination },    

    props: [
      'locale',
      'filter_params',
      'filter_path',
      'base_path',
      'exams',
      'user_name',
      'locations',
      'pagination_limit',
      'default_location'
    ],

    data() {
      return {
        loading: false,
        error: false,
        examData: [],
        message_text: [],
        message_type: "",
        locationData: [],
        selectedLocation: null,
        tempData: [],
        displayItems: [],
      }
    },

    mounted() {
      this.$i18n.locale = this.locale;

      try{
        this.examData = JSON.parse(this.exams)
        this.tempData = this.examData
        this.locationData = JSON.parse(this.locations)
        this.selectedLocation = this.default_location ? this.locationData.find(location => location.id == JSON.parse(this.default_location).id) : null;

        if(this.selectedLocation){
          this.selectedLocation = {id: this.selectedLocation.id, value: this.selectedLocation.label}
        }
      }
      catch(err){
        this.error = true;
      }
    },

    computed: {
      setData() {
        if(this.tempData == []) {
          this.displayItems = []
        }
      }
    },

    methods: {
      formatDate(dateString) {
        return formatDate(dateString)
      },

      setItems(items) {
        this.displayItems = items
      },

      onChange(event) {
          let data = []
          let selectedLocationId = this.selectedLocation ? this.selectedLocation.id : null 
          this.examData.forEach((exam) => {
            if(exam.inventory_items.length > 0 && (this.selectedLocation == {} || exam.inventory_items.find((item) => item.container_id == selectedLocationId))) {
              data.push(exam)
            }
          })
          
          this.tempData = data;
      },

      sortBooksByStatus(inventory_items, status=null) {
        let returnItems = []
        if(inventory_items.length <= 0){
          return returnItems
        }
        else {
          inventory_items.forEach((item) => {
            let selectedLocationId = this.selectedLocation ? this.selectedLocation.id : null 

            if((!status || (status && item.status == status)) && item.container_id == selectedLocationId){
              returnItems.push(parseInt(item.code))
            }
          })
          
        }
        return returnItems
        
      },

      listBooksByStatus(inventory_items, status) {
        let returnItems = this.sortBooksByStatus(inventory_items, status)
        if(returnItems.length <= 0){
          return this.$i18n.t('none')
        }
        return returnItems.join(',')
      }
    }

  }
</script>
